/* @generated from adl module ferovinum.app.workflow */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_common from './common';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_systemcommand from './systemcommand';
import * as ferovinum_app_types from './types';

export interface WorkflowHistory {
  prevState: (WfState|null);
  action: WfAction;
  systemCommands: ferovinum_app_systemcommand.SystemCmd[];
  timestamp: common.Instant;
}

export function makeWorkflowHistory(
  input: {
    prevState: (WfState|null),
    action: WfAction,
    systemCommands: ferovinum_app_systemcommand.SystemCmd[],
    timestamp: common.Instant,
  }
): WorkflowHistory {
  return {
    prevState: input.prevState,
    action: input.action,
    systemCommands: input.systemCommands,
    timestamp: input.timestamp,
  };
}

const WorkflowHistory_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"prevState","default":{"kind":"nothing"},"name":"prevState","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfState"}},"parameters":[]}]}},{"annotations":[],"serializedName":"action","default":{"kind":"nothing"},"name":"action","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"WfAction"}},"parameters":[]}},{"annotations":[],"serializedName":"systemCommands","default":{"kind":"nothing"},"name":"systemCommands","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.systemcommand","name":"SystemCmd"}},"parameters":[]}]}},{"annotations":[],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"WorkflowHistory","version":{"kind":"nothing"}}};

export const snWorkflowHistory: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WorkflowHistory"};

export function texprWorkflowHistory(): ADL.ATypeExpr<WorkflowHistory> {
  return {value : {typeRef : {kind: "reference", value : snWorkflowHistory}, parameters : []}};
}

export interface WfState_Stock_movement {
  kind: 'stock_movement';
  value: StockMovementWfState;
}
export interface WfState_Transport {
  kind: 'transport';
  value: TransportWfState;
}

export type WfState = WfState_Stock_movement | WfState_Transport;

export interface WfStateOpts {
  stock_movement: StockMovementWfState;
  transport: TransportWfState;
}

export function makeWfState<K extends keyof WfStateOpts>(kind: K, value: WfStateOpts[K]) { return {kind, value}; }

const WfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock_movement","default":{"kind":"nothing"},"name":"stock_movement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementWfState"}},"parameters":[]}},{"annotations":[],"serializedName":"transport","default":{"kind":"nothing"},"name":"transport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfState"}},"parameters":[]}}]}},"name":"WfState","version":{"kind":"nothing"}}};

export const snWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfState"};

export function texprWfState(): ADL.ATypeExpr<WfState> {
  return {value : {typeRef : {kind: "reference", value : snWfState}, parameters : []}};
}

export interface WfAction_Stock_movement {
  kind: 'stock_movement';
  value: StockMovementWfAction;
}
export interface WfAction_Transport {
  kind: 'transport';
  value: TransportWfAction;
}

export type WfAction = WfAction_Stock_movement | WfAction_Transport;

export interface WfActionOpts {
  stock_movement: StockMovementWfAction;
  transport: TransportWfAction;
}

export function makeWfAction<K extends keyof WfActionOpts>(kind: K, value: WfActionOpts[K]) { return {kind, value}; }

const WfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stock_movement","default":{"kind":"nothing"},"name":"stock_movement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementWfAction"}},"parameters":[]}},{"annotations":[],"serializedName":"transport","default":{"kind":"nothing"},"name":"transport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfAction"}},"parameters":[]}}]}},"name":"WfAction","version":{"kind":"nothing"}}};

export const snWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"WfAction"};

export function texprWfAction(): ADL.ATypeExpr<WfAction> {
  return {value : {typeRef : {kind: "reference", value : snWfAction}, parameters : []}};
}

export type StockMovementWfState = 'requested' | 'approved' | 'rejected' | 'cancelled' | 'completed';
export const valuesStockMovementWfState : StockMovementWfState[] = ['requested', 'approved', 'rejected', 'cancelled', 'completed'];

const StockMovementWfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"requested","default":{"kind":"nothing"},"name":"requested","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"approved","default":{"kind":"nothing"},"name":"approved","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"rejected","default":{"kind":"nothing"},"name":"rejected","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancelled","default":{"kind":"nothing"},"name":"cancelled","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"StockMovementWfState","version":{"kind":"nothing"}}};

export const snStockMovementWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementWfState"};

export function texprStockMovementWfState(): ADL.ATypeExpr<StockMovementWfState> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementWfState}, parameters : []}};
}

export interface StockMovementWfApproveAction {
  titleHolder: ferovinum_app_db.FeroEntity;
}

export function makeStockMovementWfApproveAction(
  input: {
    titleHolder: ferovinum_app_db.FeroEntity,
  }
): StockMovementWfApproveAction {
  return {
    titleHolder: input.titleHolder,
  };
}

const StockMovementWfApproveAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"titleHolder","default":{"kind":"nothing"},"name":"titleHolder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"FeroEntity"}},"parameters":[]}}]}},"name":"StockMovementWfApproveAction","version":{"kind":"nothing"}}};

export const snStockMovementWfApproveAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementWfApproveAction"};

export function texprStockMovementWfApproveAction(): ADL.ATypeExpr<StockMovementWfApproveAction> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementWfApproveAction}, parameters : []}};
}

export interface StockMovementWfAction_Request {
  kind: 'request';
  value: StockMovementReq;
}
export interface StockMovementWfAction_Approve {
  kind: 'approve';
  value: StockMovementWfApproveAction;
}
export interface StockMovementWfAction_Reject {
  kind: 'reject';
}
export interface StockMovementWfAction_Cancel {
  kind: 'cancel';
}
export interface StockMovementWfAction_Complete {
  kind: 'complete';
}

export type StockMovementWfAction = StockMovementWfAction_Request | StockMovementWfAction_Approve | StockMovementWfAction_Reject | StockMovementWfAction_Cancel | StockMovementWfAction_Complete;

export interface StockMovementWfActionOpts {
  request: StockMovementReq;
  approve: StockMovementWfApproveAction;
  reject: null;
  cancel: null;
  complete: null;
}

export function makeStockMovementWfAction<K extends keyof StockMovementWfActionOpts>(kind: K, value: StockMovementWfActionOpts[K]) { return {kind, value}; }

const StockMovementWfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementReq"}},"parameters":[]}},{"annotations":[],"serializedName":"approve","default":{"kind":"nothing"},"name":"approve","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementWfApproveAction"}},"parameters":[]}},{"annotations":[],"serializedName":"reject","default":{"kind":"nothing"},"name":"reject","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancel","default":{"kind":"nothing"},"name":"cancel","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"complete","default":{"kind":"nothing"},"name":"complete","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"StockMovementWfAction","version":{"kind":"nothing"}}};

export const snStockMovementWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementWfAction"};

export function texprStockMovementWfAction(): ADL.ATypeExpr<StockMovementWfAction> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementWfAction}, parameters : []}};
}

export type TransportWfState = 'awaiting_delivery' | 'collected' | 'delivered' | 'delivery_confirmed';
export const valuesTransportWfState : TransportWfState[] = ['awaiting_delivery', 'collected', 'delivered', 'delivery_confirmed'];

const TransportWfState_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"awaiting_delivery","default":{"kind":"nothing"},"name":"awaiting_delivery","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"collected","default":{"kind":"nothing"},"name":"collected","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delivered","default":{"kind":"nothing"},"name":"delivered","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delivery_confirmed","default":{"kind":"nothing"},"name":"delivery_confirmed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"TransportWfState","version":{"kind":"nothing"}}};

export const snTransportWfState: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfState"};

export function texprTransportWfState(): ADL.ATypeExpr<TransportWfState> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfState}, parameters : []}};
}

export interface TransportWfAction_Request {
  kind: 'request';
  value: TransportWfData;
}
export interface TransportWfAction_Collect {
  kind: 'collect';
}
export interface TransportWfAction_Deliver {
  kind: 'deliver';
}
export interface TransportWfAction_Confirm_delivery {
  kind: 'confirm_delivery';
}

export type TransportWfAction = TransportWfAction_Request | TransportWfAction_Collect | TransportWfAction_Deliver | TransportWfAction_Confirm_delivery;

export interface TransportWfActionOpts {
  request: TransportWfData;
  collect: null;
  deliver: null;
  confirm_delivery: null;
}

export function makeTransportWfAction<K extends keyof TransportWfActionOpts>(kind: K, value: TransportWfActionOpts[K]) { return {kind, value}; }

const TransportWfAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"request","default":{"kind":"nothing"},"name":"request","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfData"}},"parameters":[]}},{"annotations":[],"serializedName":"collect","default":{"kind":"nothing"},"name":"collect","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"deliver","default":{"kind":"nothing"},"name":"deliver","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"confirm_delivery","default":{"kind":"nothing"},"name":"confirm_delivery","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"TransportWfAction","version":{"kind":"nothing"}}};

export const snTransportWfAction: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfAction"};

export function texprTransportWfAction(): ADL.ATypeExpr<TransportWfAction> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfAction}, parameters : []}};
}

export interface StockMovementDeliveryOption_CollectionByOrg {
  kind: 'collectionByOrg';
  value: StockMovementCollection;
}
export interface StockMovementDeliveryOption_OrganisedDelivery {
  kind: 'organisedDelivery';
  value: StockMovementDelivery;
}

export type StockMovementDeliveryOption = StockMovementDeliveryOption_CollectionByOrg | StockMovementDeliveryOption_OrganisedDelivery;

export interface StockMovementDeliveryOptionOpts {
  collectionByOrg: StockMovementCollection;
  organisedDelivery: StockMovementDelivery;
}

export function makeStockMovementDeliveryOption<K extends keyof StockMovementDeliveryOptionOpts>(kind: K, value: StockMovementDeliveryOptionOpts[K]) { return {kind, value}; }

const StockMovementDeliveryOption_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionByOrg","default":{"kind":"nothing"},"name":"collectionByOrg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementCollection"}},"parameters":[]}},{"annotations":[],"serializedName":"organisedDelivery","default":{"kind":"nothing"},"name":"organisedDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementDelivery"}},"parameters":[]}}]}},"name":"StockMovementDeliveryOption","version":{"kind":"nothing"}}};

export const snStockMovementDeliveryOption: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementDeliveryOption"};

export function texprStockMovementDeliveryOption(): ADL.ATypeExpr<StockMovementDeliveryOption> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementDeliveryOption}, parameters : []}};
}

export interface StockMovementCollection {
  collectionDate: common.LocalDate;
  collectionTime: common.LocalTime;
  deliveryDate: common.LocalDate;
  carrierName: string;
  contactName: string;
  contactEmail: string;
  contactNumber: string;
  vehicleRegistration: (string|null);
  movementGuaranteeNumber: (string|null);
}

export function makeStockMovementCollection(
  input: {
    collectionDate: common.LocalDate,
    collectionTime: common.LocalTime,
    deliveryDate: common.LocalDate,
    carrierName: string,
    contactName: string,
    contactEmail: string,
    contactNumber: string,
    vehicleRegistration: (string|null),
    movementGuaranteeNumber?: (string|null),
  }
): StockMovementCollection {
  return {
    collectionDate: input.collectionDate,
    collectionTime: input.collectionTime,
    deliveryDate: input.deliveryDate,
    carrierName: input.carrierName,
    contactName: input.contactName,
    contactEmail: input.contactEmail,
    contactNumber: input.contactNumber,
    vehicleRegistration: input.vehicleRegistration,
    movementGuaranteeNumber: input.movementGuaranteeNumber === undefined ? null : input.movementGuaranteeNumber,
  };
}

const StockMovementCollection_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"collectionDate","default":{"kind":"nothing"},"name":"collectionDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"collectionTime","default":{"kind":"nothing"},"name":"collectionTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryDate","default":{"kind":"nothing"},"name":"deliveryDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"carrierName","default":{"kind":"nothing"},"name":"carrierName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"contactNumber","default":{"kind":"nothing"},"name":"contactNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"vehicleRegistration","default":{"kind":"nothing"},"name":"vehicleRegistration","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"movementGuaranteeNumber","default":{"kind":"just","value":null},"name":"movementGuaranteeNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"StockMovementCollection","version":{"kind":"nothing"}}};

export const snStockMovementCollection: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementCollection"};

export function texprStockMovementCollection(): ADL.ATypeExpr<StockMovementCollection> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementCollection}, parameters : []}};
}

export interface StockMovementDelivery {
  carrier: ferovinum_app_db.CarrierId;
  deliveryDate: common.LocalDate;
  deliveryTimeEarliest: common.LocalTime;
  deliveryTimeLatest: common.LocalTime;
  deliveryInstructions: (string|null);
}

export function makeStockMovementDelivery(
  input: {
    carrier: ferovinum_app_db.CarrierId,
    deliveryDate: common.LocalDate,
    deliveryTimeEarliest: common.LocalTime,
    deliveryTimeLatest: common.LocalTime,
    deliveryInstructions: (string|null),
  }
): StockMovementDelivery {
  return {
    carrier: input.carrier,
    deliveryDate: input.deliveryDate,
    deliveryTimeEarliest: input.deliveryTimeEarliest,
    deliveryTimeLatest: input.deliveryTimeLatest,
    deliveryInstructions: input.deliveryInstructions,
  };
}

const StockMovementDelivery_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"carrier","default":{"kind":"nothing"},"name":"carrier","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CarrierId"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryDate","default":{"kind":"nothing"},"name":"deliveryDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryTimeEarliest","default":{"kind":"nothing"},"name":"deliveryTimeEarliest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryTimeLatest","default":{"kind":"nothing"},"name":"deliveryTimeLatest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryInstructions","default":{"kind":"nothing"},"name":"deliveryInstructions","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"StockMovementDelivery","version":{"kind":"nothing"}}};

export const snStockMovementDelivery: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementDelivery"};

export function texprStockMovementDelivery(): ADL.ATypeExpr<StockMovementDelivery> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementDelivery}, parameters : []}};
}

export interface StockMovementReq {
  orgId: ferovinum_app_db.OrganisationId;
  startingLocationId: ferovinum_app_db.StorageLocationId;
  destinationLocationId: ferovinum_app_db.StorageLocationId;
  stockToMove: ferovinum_app_common.ProductIdQuantity[];
  stockMovementDeliveryOption: StockMovementDeliveryOption;
}

export function makeStockMovementReq(
  input: {
    orgId: ferovinum_app_db.OrganisationId,
    startingLocationId: ferovinum_app_db.StorageLocationId,
    destinationLocationId: ferovinum_app_db.StorageLocationId,
    stockToMove: ferovinum_app_common.ProductIdQuantity[],
    stockMovementDeliveryOption: StockMovementDeliveryOption,
  }
): StockMovementReq {
  return {
    orgId: input.orgId,
    startingLocationId: input.startingLocationId,
    destinationLocationId: input.destinationLocationId,
    stockToMove: input.stockToMove,
    stockMovementDeliveryOption: input.stockMovementDeliveryOption,
  };
}

const StockMovementReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"orgId","default":{"kind":"nothing"},"name":"orgId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"startingLocationId","default":{"kind":"nothing"},"name":"startingLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"destinationLocationId","default":{"kind":"nothing"},"name":"destinationLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"stockToMove","default":{"kind":"nothing"},"name":"stockToMove","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.common","name":"ProductIdQuantity"}},"parameters":[]}]}},{"annotations":[],"serializedName":"stockMovementDeliveryOption","default":{"kind":"nothing"},"name":"stockMovementDeliveryOption","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementDeliveryOption"}},"parameters":[]}}]}},"name":"StockMovementReq","version":{"kind":"nothing"}}};

export const snStockMovementReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockMovementReq"};

export function texprStockMovementReq(): ADL.ATypeExpr<StockMovementReq> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementReq}, parameters : []}};
}

export interface TransportWfProduct {
  productId: ferovinum_app_db.ProductId;
  quantity: ferovinum_app_db.NumberOfUnits;
  rotationNumber: (string|null);
  price: ferovinum_app_types.Decimal;
  currency: ferovinum_app_db.Currency;
  singlesPerCase: (number|null);
}

export function makeTransportWfProduct(
  input: {
    productId: ferovinum_app_db.ProductId,
    quantity: ferovinum_app_db.NumberOfUnits,
    rotationNumber: (string|null),
    price: ferovinum_app_types.Decimal,
    currency: ferovinum_app_db.Currency,
    singlesPerCase: (number|null),
  }
): TransportWfProduct {
  return {
    productId: input.productId,
    quantity: input.quantity,
    rotationNumber: input.rotationNumber,
    price: input.price,
    currency: input.currency,
    singlesPerCase: input.singlesPerCase,
  };
}

const TransportWfProduct_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"price","default":{"kind":"nothing"},"name":"price","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"singlesPerCase","default":{"kind":"nothing"},"name":"singlesPerCase","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}}]}},"name":"TransportWfProduct","version":{"kind":"nothing"}}};

export const snTransportWfProduct: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfProduct"};

export function texprTransportWfProduct(): ADL.ATypeExpr<TransportWfProduct> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfProduct}, parameters : []}};
}

export interface TransportWfData {
  reference: common_strings.StringNE;
  startingLocationId: ferovinum_app_db.StorageLocationId;
  destinationLocationId: ferovinum_app_db.StorageLocationId;
  deliveryOption: StockMovementDeliveryOption;
  stockToMove: TransportWfProduct[];
  deliveryStatuses: ferovinum_app_db.DeliveryStatus[];
}

export function makeTransportWfData(
  input: {
    reference: common_strings.StringNE,
    startingLocationId: ferovinum_app_db.StorageLocationId,
    destinationLocationId: ferovinum_app_db.StorageLocationId,
    deliveryOption: StockMovementDeliveryOption,
    stockToMove: TransportWfProduct[],
    deliveryStatuses: ferovinum_app_db.DeliveryStatus[],
  }
): TransportWfData {
  return {
    reference: input.reference,
    startingLocationId: input.startingLocationId,
    destinationLocationId: input.destinationLocationId,
    deliveryOption: input.deliveryOption,
    stockToMove: input.stockToMove,
    deliveryStatuses: input.deliveryStatuses,
  };
}

const TransportWfData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"startingLocationId","default":{"kind":"nothing"},"name":"startingLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"destinationLocationId","default":{"kind":"nothing"},"name":"destinationLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"deliveryOption","default":{"kind":"nothing"},"name":"deliveryOption","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockMovementDeliveryOption"}},"parameters":[]}},{"annotations":[],"serializedName":"stockToMove","default":{"kind":"nothing"},"name":"stockToMove","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"TransportWfProduct"}},"parameters":[]}]}},{"annotations":[],"serializedName":"deliveryStatuses","default":{"kind":"nothing"},"name":"deliveryStatuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DeliveryStatus"}},"parameters":[]}]}}]}},"name":"TransportWfData","version":{"kind":"nothing"}}};

export const snTransportWfData: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"TransportWfData"};

export function texprTransportWfData(): ADL.ATypeExpr<TransportWfData> {
  return {value : {typeRef : {kind: "reference", value : snTransportWfData}, parameters : []}};
}

export interface CreatePositiveStockAdjustmentReq {
  storageLocationId: ferovinum_app_db.StorageLocationId;
  adjustmentsToCreate: StockAdjustmentDetails[];
  comments: (common_strings.StringNE|null);
  /**
   * Reference number will be assigned by the backend if not supplied
   */
  referenceNumber: (common_strings.StringNE|null);
}

export function makeCreatePositiveStockAdjustmentReq(
  input: {
    storageLocationId: ferovinum_app_db.StorageLocationId,
    adjustmentsToCreate: StockAdjustmentDetails[],
    comments: (common_strings.StringNE|null),
    referenceNumber: (common_strings.StringNE|null),
  }
): CreatePositiveStockAdjustmentReq {
  return {
    storageLocationId: input.storageLocationId,
    adjustmentsToCreate: input.adjustmentsToCreate,
    comments: input.comments,
    referenceNumber: input.referenceNumber,
  };
}

const CreatePositiveStockAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"adjustmentsToCreate","default":{"kind":"nothing"},"name":"adjustmentsToCreate","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentDetails"}},"parameters":[]}]}},{"annotations":[],"serializedName":"comments","default":{"kind":"nothing"},"name":"comments","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"value":"Reference number will be assigned by the backend if not supplied\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"referenceNumber","default":{"kind":"nothing"},"name":"referenceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CreatePositiveStockAdjustmentReq","version":{"kind":"nothing"}}};

export const snCreatePositiveStockAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"CreatePositiveStockAdjustmentReq"};

export function texprCreatePositiveStockAdjustmentReq(): ADL.ATypeExpr<CreatePositiveStockAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snCreatePositiveStockAdjustmentReq}, parameters : []}};
}

export interface StockAdjustmentDetails {
  organisationId: ferovinum_app_db.OrganisationId;
  productId: ferovinum_app_db.ProductId;
  quantity: ferovinum_app_db.NumberOfUnits;
  batchNumber: (string|null);
  rotationNumber: (string|null);
  rotationLine: (number|null);
  bestBefore: (common.LocalDate|null);
  dutyPaid: (boolean|null);
}

export function makeStockAdjustmentDetails(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
    productId: ferovinum_app_db.ProductId,
    quantity: ferovinum_app_db.NumberOfUnits,
    batchNumber: (string|null),
    rotationNumber: (string|null),
    rotationLine: (number|null),
    bestBefore: (common.LocalDate|null),
    dutyPaid: (boolean|null),
  }
): StockAdjustmentDetails {
  return {
    organisationId: input.organisationId,
    productId: input.productId,
    quantity: input.quantity,
    batchNumber: input.batchNumber,
    rotationNumber: input.rotationNumber,
    rotationLine: input.rotationLine,
    bestBefore: input.bestBefore,
    dutyPaid: input.dutyPaid,
  };
}

const StockAdjustmentDetails_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"batchNumber","default":{"kind":"nothing"},"name":"batchNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationLine","default":{"kind":"nothing"},"name":"rotationLine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}},{"annotations":[],"serializedName":"bestBefore","default":{"kind":"nothing"},"name":"bestBefore","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"dutyPaid","default":{"kind":"nothing"},"name":"dutyPaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}}]}},"name":"StockAdjustmentDetails","version":{"kind":"nothing"}}};

export const snStockAdjustmentDetails: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockAdjustmentDetails"};

export function texprStockAdjustmentDetails(): ADL.ATypeExpr<StockAdjustmentDetails> {
  return {value : {typeRef : {kind: "reference", value : snStockAdjustmentDetails}, parameters : []}};
}

export interface StockAdjustmentEntity_RotationNumber {
  kind: 'rotationNumber';
  value: string;
}
export interface StockAdjustmentEntity_ProductId {
  kind: 'productId';
  value: ferovinum_app_db.ProductId;
}

export type StockAdjustmentEntity = StockAdjustmentEntity_RotationNumber | StockAdjustmentEntity_ProductId;

export interface StockAdjustmentEntityOpts {
  /**
   * A rotation number linked to a product to deplete
   */
  rotationNumber: string;
  /**
   * A product ID, the backend will decide on which deal legs to deplete. The
   * product should only belong to a single client
   */
  productId: ferovinum_app_db.ProductId;
}

export function makeStockAdjustmentEntity<K extends keyof StockAdjustmentEntityOpts>(kind: K, value: StockAdjustmentEntityOpts[K]) { return {kind, value}; }

const StockAdjustmentEntity_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"A rotation number linked to a product to deplete\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"A product ID, the backend will decide on which deal legs to deplete. The\nproduct should only belong to a single client\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}}]}},"name":"StockAdjustmentEntity","version":{"kind":"nothing"}}};

export const snStockAdjustmentEntity: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockAdjustmentEntity"};

export function texprStockAdjustmentEntity(): ADL.ATypeExpr<StockAdjustmentEntity> {
  return {value : {typeRef : {kind: "reference", value : snStockAdjustmentEntity}, parameters : []}};
}

export interface StockAdjustmentToCreate {
  stockAdjustmentEntity: StockAdjustmentEntity;
  numberOfUnits: ferovinum_app_db.NumberOfUnits;
}

export function makeStockAdjustmentToCreate(
  input: {
    stockAdjustmentEntity: StockAdjustmentEntity,
    numberOfUnits: ferovinum_app_db.NumberOfUnits,
  }
): StockAdjustmentToCreate {
  return {
    stockAdjustmentEntity: input.stockAdjustmentEntity,
    numberOfUnits: input.numberOfUnits,
  };
}

const StockAdjustmentToCreate_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"stockAdjustmentEntity","default":{"kind":"nothing"},"name":"stockAdjustmentEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentEntity"}},"parameters":[]}},{"annotations":[],"serializedName":"numberOfUnits","default":{"kind":"nothing"},"name":"numberOfUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"StockAdjustmentToCreate","version":{"kind":"nothing"}}};

export const snStockAdjustmentToCreate: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockAdjustmentToCreate"};

export function texprStockAdjustmentToCreate(): ADL.ATypeExpr<StockAdjustmentToCreate> {
  return {value : {typeRef : {kind: "reference", value : snStockAdjustmentToCreate}, parameters : []}};
}

export interface StockAdjustmentReq {
  storageLocationId: ferovinum_app_db.StorageLocationId;
  reimbursingCosts: boolean;
  comment: (string|null);
  reference: (string|null);
  stockDifferences: StockAdjustmentToCreate[];
}

export function makeStockAdjustmentReq(
  input: {
    storageLocationId: ferovinum_app_db.StorageLocationId,
    reimbursingCosts: boolean,
    comment: (string|null),
    reference: (string|null),
    stockDifferences: StockAdjustmentToCreate[],
  }
): StockAdjustmentReq {
  return {
    storageLocationId: input.storageLocationId,
    reimbursingCosts: input.reimbursingCosts,
    comment: input.comment,
    reference: input.reference,
    stockDifferences: input.stockDifferences,
  };
}

const StockAdjustmentReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.workflow","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"reimbursingCosts","default":{"kind":"nothing"},"name":"reimbursingCosts","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"comment","default":{"kind":"nothing"},"name":"comment","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"stockDifferences","default":{"kind":"nothing"},"name":"stockDifferences","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.workflow","name":"StockAdjustmentToCreate"}},"parameters":[]}]}}]}},"name":"StockAdjustmentReq","version":{"kind":"nothing"}}};

export const snStockAdjustmentReq: ADL.ScopedName = {moduleName:"ferovinum.app.workflow", name:"StockAdjustmentReq"};

export function texprStockAdjustmentReq(): ADL.ATypeExpr<StockAdjustmentReq> {
  return {value : {typeRef : {kind: "reference", value : snStockAdjustmentReq}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.workflow.WorkflowHistory" : WorkflowHistory_AST,
  "ferovinum.app.workflow.WfState" : WfState_AST,
  "ferovinum.app.workflow.WfAction" : WfAction_AST,
  "ferovinum.app.workflow.StockMovementWfState" : StockMovementWfState_AST,
  "ferovinum.app.workflow.StockMovementWfApproveAction" : StockMovementWfApproveAction_AST,
  "ferovinum.app.workflow.StockMovementWfAction" : StockMovementWfAction_AST,
  "ferovinum.app.workflow.TransportWfState" : TransportWfState_AST,
  "ferovinum.app.workflow.TransportWfAction" : TransportWfAction_AST,
  "ferovinum.app.workflow.StockMovementDeliveryOption" : StockMovementDeliveryOption_AST,
  "ferovinum.app.workflow.StockMovementCollection" : StockMovementCollection_AST,
  "ferovinum.app.workflow.StockMovementDelivery" : StockMovementDelivery_AST,
  "ferovinum.app.workflow.StockMovementReq" : StockMovementReq_AST,
  "ferovinum.app.workflow.TransportWfProduct" : TransportWfProduct_AST,
  "ferovinum.app.workflow.TransportWfData" : TransportWfData_AST,
  "ferovinum.app.workflow.CreatePositiveStockAdjustmentReq" : CreatePositiveStockAdjustmentReq_AST,
  "ferovinum.app.workflow.StockAdjustmentDetails" : StockAdjustmentDetails_AST,
  "ferovinum.app.workflow.StockAdjustmentEntity" : StockAdjustmentEntity_AST,
  "ferovinum.app.workflow.StockAdjustmentToCreate" : StockAdjustmentToCreate_AST,
  "ferovinum.app.workflow.StockAdjustmentReq" : StockAdjustmentReq_AST
};
